import { defineSlotRecipe } from '@chakra-ui/react'

export const periodPagerRecipe = defineSlotRecipe({
  className: 'period-pager',
  slots: ['root', 'label'],
  base: {
    root: {
      display: 'inline-flex',
      alignItems: 'stretch',
      justifyContent: 'space-between',
      borderWidth: '1px',
      borderColor: 'border',
      borderRadius: 'l1',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: '24',
      paddingInline: '3',
      textStyle: 'body',
      whiteSpace: 'nowrap',
    },
  },
})
